import React, { useState, useEffect } from 'react'
import './styles/Table.css'
import './styles/crearFormulario.scss'
import MaterialTable from 'material-table'
// import GetAppIcon from '@material-ui/icons/GetApp'
// import FileUploadIcon from '@mui/icons-material/FileUpload'
// import CheckIcon from '@mui/icons-material/Check'
// import ClearIcon from '@mui/icons-material/Clear'
import { Grid, Box, Button } from '@material-ui/core'
import Swal from 'sweetalert2'
// import swal from 'sweetalert'
import CircularProgress from '@mui/material/CircularProgress'

// import { useHistory } from 'react-router-dom'
import { useAuthentication } from '../../../../context/authenticationContext'
// import { ModalRechazar } from '../RepresentarMipyme/Modals/ModalRechazar'
import { getPendientesWorkshop } from '../../../../services/Workshop/get'
import { senPendientesWorkshop } from '../../../../services/Workshop/create'
// import { AprobarRechazarRepresentar } from '../../../../services/Representacion/create'

const TableSolicitudWorkshop = () => {
  const { IdIFIToken } = useAuthentication()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // setLoading(true)
    getNotificaciones()
  }, [])

  const getNotificaciones = async () => {
    try {
      const response = await getPendientesWorkshop(IdIFIToken)
      if (response.Success) {
        if (response.Data.length > 0) {
          setTableForms(response.Data)
        } else {
          setTableForms([])
        }
      }
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
    setLoading(false)
  }

  const columns = [
    {
      title: 'Nombre Mipyme',
      field: 'BusinessName',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Tipo De MIPYME',
      field: 'MipymeType',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
  ]

  const [TableForms, setTableForms] = useState([])

  const [ArraySend, setArraySend] = useState([])

  const handleSend = async () => {
    try {
      const response = await senPendientesWorkshop(ArraySend)
      if (response.Success) {
        Swal.fire({
          title: 'Notificaciones Enviadas!',
          icon: 'success',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Entendido',
        })
        getNotificaciones()
      } else {
        Swal.fire({
          title: 'Ocurrio un Error al eliminar la notificación',
          icon: 'error',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Entendido',
        })
        getNotificaciones()
      }
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <section>
      {!loading ? (
        <Grid
          container
          style={{
            width: '100%',
            height: 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              height: 'auto',
              width: '96%',
              backgroundColor: '#fff',
              borderRadius: '4px',
            }}
          >
            <div className="App">
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12}>
                  <MaterialTable
                    columns={columns}
                    data={TableForms}
                    // actions={[
                    //   {
                    //     icon: () => <CheckIcon color="success" />,
                    //     tooltip: 'Aprobar',
                    //     onClick: (event, rowData) => {
                    //       AprobarSolicitud(rowData.IdNotification)
                    //     },
                    //   },
                    //   {
                    //     icon: () => <ClearIcon color="error" />,
                    //     tooltip: 'Rechazar',
                    //     onClick: (event, rowData) => {
                    //       handleOpen(true)
                    //       setIdNotification(rowData.IdNotification)
                    //     },
                    //   },
                    // ]}
                    onSelectionChange={(selectedRows) =>
                      setArraySend(selectedRows)
                    }
                    options={{
                      sorting: true,
                      search: true,
                      searchFieldAlignment: 'right',
                      searchAutoFocus: true,
                      searchFieldVariant: 'standard',
                      filtering: true,
                      paging: true,
                      pageSizeOptions: [2, 5, 10, 20],
                      pageSize: 5,
                      paginationType: 'stepped',
                      showFirstLastPageButtons: false,
                      paginationPosition: 'bottom',
                      exportButton: true,
                      exportAllData: true,
                      exportFileName: 'TableData',
                      // addRowPosition: 'first',
                      actionsColumnIndex: -1,
                      selection: true,
                      showSelectAllCheckbox: false,
                      showTextRowsSelected: false,
                      selectionProps: (rowData) => ({
                        // disabled: rowData.age == null,
                        // color:"primary"
                      }),
                      // grouping: true,
                      columnsButton: true,
                      rowStyle: (data, index) =>
                        index % 2 === 0 ? { background: '#f5f5f5' } : null,
                      headerStyle: { background: '#014b96', color: '#fff' },
                    }}
                    localization={{
                      body: {
                        editRow: {
                          deleteText: '¿Está seguro de eliminar el registro?',
                        },
                      },
                      header: {
                        actions: 'Acciones',
                      },
                      toolbar: {
                        searchPlaceholder: 'Buscar',
                      },
                    }}
                    title=" "
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-end',
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={() => handleSend()}
                    color="primary"
                  >
                    Enviar
                  </Button>
                </Grid>
              </Grid>
              {/* <ModalRechazar
                open={openObservation}
                setOpen={setOpenObservation}
                idNotification={IdNotification}
              /> */}
            </div>
          </div>
        </Grid>
      ) : (
        <Box className="loadingEditContainer">
          <Grid className="loadingSub">
            <CircularProgress />
          </Grid>
        </Box>
      )}
    </section>
  )
}
export default TableSolicitudWorkshop
